import { PaymentProviderType } from '../models';
// NOW ALSO USED FOR SMS! TODO: RENAME
export var EmailTemplateTypes;
(function (EmailTemplateTypes) {
    EmailTemplateTypes["LATE_FEE"] = "LATE_FEE";
    EmailTemplateTypes["REMINDER"] = "REMINDER";
    EmailTemplateTypes["AFTER_MARKED_PAID"] = "AFTER_MARKED_PAID";
    EmailTemplateTypes["DISCOUNT"] = "DISCOUNT";
    EmailTemplateTypes["LEGACY_LATE_FEE"] = "LEGACY_LATE_FEE";
    EmailTemplateTypes["STATEMENT_EMAIL"] = "STATEMENT_EMAIL";
    EmailTemplateTypes["STATEMENT_INTEREST_EMAIL"] = "STATEMENT_INTEREST_EMAIL";
    EmailTemplateTypes["SMS"] = "SMS";
    EmailTemplateTypes["QUOTE"] = "QUOTE";
    EmailTemplateTypes["ESCALATION"] = "ESCALATION";
    /** Used for invoice reference custom field in policy */
    EmailTemplateTypes["INVOICE_REFERENCE"] = "INVOICE_REFERENCE";
    /** Used for sending a generic announcement email template to one or more customers */
    EmailTemplateTypes["ANNOUNCEMENT"] = "ANNOUNCEMENT";
})(EmailTemplateTypes || (EmailTemplateTypes = {}));
const directXeroLink = {
    name: 'Invoice Link (Xero)',
    value: 'InvoiceLink',
    sample: '<a href="https://example.com/invoice/INV-0001" target="_blank">View Invoice Online</a>',
    appliesToAccounting: [`XERO`],
};
const xeroInvoiceRef = {
    name: 'Invoice Reference',
    value: 'InvoiceReference',
    sample: 'Client P/Order #123',
    appliesToAccounting: [`XERO`],
};
const invoicePortalLink = {
    name: `Invoice Portal Link`,
    value: 'InvoicePortalLink',
    sample: 'https://my.paidnice.com/i/example',
    new: true,
    link: true,
};
const statementPortalLink = {
    name: `Online Statement Link`,
    value: 'StatementPortalLink',
    sample: 'https://my.paidnice.com/c/example',
    link: true,
};
const quotePortalLink = {
    name: `Online Quote Link`,
    value: 'QuotePortalLink',
    sample: 'https://my.paidnice.com/q/example',
    link: true,
};
/** New gen of payment links, only include the link itself, no copy */
const pinchPaymentLink = {
    name: `Pinch Payment Link`,
    value: 'PinchPaymentLink',
    sample: 'https://api.paidnice.com/proxy/org/123/inv/abc/pay?provider=PINCH',
    link: true,
    new: true,
    requiresPaymentProvider: PaymentProviderType.PINCH,
};
const contactPersonName = {
    name: 'Contact Person Name',
    value: 'ContactPersonName',
    sample: 'John Smith',
};
const contactPersonFirstName = {
    name: 'Contact Person First Name',
    value: 'ContactPersonFirstName',
    sample: 'John',
    new: true,
};
const invoiceContactName = {
    name: 'Invoice Contact Name',
    value: 'InvoiceContactName',
    sample: 'ABC Limited',
};
const quoteContactName = {
    name: 'Contact Name',
    value: 'ContactName',
    sample: 'ABC Limited',
};
const reminderEmailBase = {
    InvoiceContactName: invoiceContactName,
    ContactPersonName: contactPersonName,
    ContactPersonFirstName: contactPersonFirstName,
    OrganisationName: {
        name: 'Your Organisation Name',
        value: 'OrganisationName',
        sample: 'My Company Ltd',
    },
    InvoiceLink: directXeroLink,
    InvoiceNumber: {
        name: 'Invoice Number',
        value: 'InvoiceNumber',
        sample: 'INV-0001',
    },
    InvoiceReference: xeroInvoiceRef,
    DueDate: {
        name: 'Due Date',
        value: 'DueDate',
        sample: '14 May 2022',
    },
    PinchPaymentLink: pinchPaymentLink,
    InvoicePortalLink: invoicePortalLink,
};
export const mergeTags = {
    [EmailTemplateTypes.LEGACY_LATE_FEE]: {
        invoice_contact_name: {
            name: 'Invoice Contact Name',
            value: '{{{invoice_contact_name}}}',
            sample: 'John',
        },
        organisation_legal_name: {
            name: 'Your Organisation Name',
            value: '{{{organisation_legal_name}}}',
            sample: 'My Company Ltd',
        },
        invoice_public_url_original: {
            name: 'Original Invoice Link',
            value: '{{{invoice_public_url_original}}}',
            archived: true,
        },
        invoice_public_url_penalty: {
            name: 'Penalty Invoice Link',
            value: '{{{invoice_public_url_penalty}}}',
            archived: true,
        },
        penalty_amount: {
            name: 'Penalty Amount',
            value: '{{{penalty_amount}}}',
            sample: '$10.00',
        },
        original_invoice_number: {
            name: 'Original Invoice Number',
            value: '{{{original_invoice_number}}}',
            sample: 'INV-0001',
        },
        original_due_date: {
            name: 'Original Due Date',
            value: '{{{original_due_date}}}',
            sample: 'INV-0001',
        },
    },
    [EmailTemplateTypes.LATE_FEE]: {
        InvoiceContactName: invoiceContactName,
        ContactPersonName: contactPersonName,
        ContactPersonFirstName: contactPersonFirstName,
        OrganisationName: {
            name: 'Your Organisation Name',
            value: 'OrganisationName',
            sample: 'My Company Ltd',
        },
        InvoiceLink: directXeroLink,
        PenaltyInvoiceLink: {
            name: 'Penalty Invoice Link',
            value: 'PenaltyInvoiceLink',
            sample: 'https://example.com/invoice/INV-0002',
            help: 'May be the same as the original invoice number if add to existing invoice is enabled',
            appliesToAccounting: [`XERO`],
        },
        PenaltyAmount: {
            name: 'Penalty Amount',
            value: 'PenaltyAmount',
            sample: '$10.00',
        },
        PenaltyInvoiceNumber: {
            name: 'Penalty Invoice Number',
            value: 'PenaltyInvoiceNumber',
            sample: 'INV-0002',
            help: 'May be the same as the original invoice number if add to existing invoice is enabled',
        },
        OriginalInvoiceNumber: {
            name: 'Original Invoice Number',
            value: 'OriginalInvoiceNumber',
            sample: 'INV-0001',
        },
        DueDate: {
            name: 'Due Date',
            value: 'DueDate',
            sample: '14 May 2022',
        },
        InvoicePortalLink: invoicePortalLink,
        PinchPaymentLink: pinchPaymentLink,
    },
    [EmailTemplateTypes.REMINDER]: Object.assign(Object.assign({}, reminderEmailBase), { DaysUntilDue: {
            name: 'Days Until Due',
            value: 'DaysUntilDue',
            sample: '14',
        }, DaysAfterDue: {
            name: 'Days After Due',
            value: 'DaysAfterDue',
            sample: '14',
        }, DueAmount: {
            name: 'Due Amount',
            value: 'DueAmount',
            sample: '$250.00',
        }, PenaltyForecastAmount: {
            name: 'Forecasted Penalty Amount',
            value: 'PenaltyForecastAmount',
            sample: '$10.00',
        }, 
        // See docs here: https://www.notion.so/paidnice/PaymentLink-payment-links-in-emails-and-statements-88f62010bee04c4086144825dac0b126
        PaymentLink: {
            name: 'Payment link',
            value: 'PaymentLink',
            sample: 'Please pay here https://example-payments.com/pay/INV-001',
        } }),
    [EmailTemplateTypes.AFTER_MARKED_PAID]: Object.assign(Object.assign({}, reminderEmailBase), { MarkedPaidDate: {
            name: 'Marked Paid Date',
            value: 'MarkedPaidDate',
            sample: '14 May 2022',
        } }),
    [EmailTemplateTypes.SMS]: {
        InvoiceContactName: invoiceContactName,
        ContactPersonName: contactPersonName,
        ContactPersonFirstName: contactPersonFirstName,
        OrganisationName: {
            name: 'Your Organisation Name',
            value: 'OrganisationName',
            sample: 'My Company Ltd',
        },
        InvoiceLink: {
            name: 'Invoice Link',
            value: 'InvoiceLink',
            sample: '<a href="https://example.com/invoice/INV-0001" target="_blank">View Invoice Online</a>',
            archived: true,
        },
        PenaltyForecastAmount: {
            name: 'Forecasted Penalty Amount',
            value: 'PenaltyForecastAmount',
            sample: '$10.00',
        },
        InvoiceNumber: {
            name: 'Invoice Number',
            value: 'InvoiceNumber',
            sample: 'INV-0001',
        },
        DueDate: {
            name: 'Due Date',
            value: 'DueDate',
            sample: '14 May 2022',
        },
        DaysUntilDue: {
            name: 'Days Until Due',
            value: 'DaysUntilDue',
            sample: '14',
        },
        DaysAfterDue: {
            name: 'Days After Due',
            value: 'DaysAfterDue',
            sample: '14',
        },
        DueAmount: {
            name: 'Due Amount',
            value: 'DueAmount',
            sample: '$250.00',
        },
        // See docs here: https://www.notion.so/paidnice/PaymentLink-payment-links-in-emails-and-statements-88f62010bee04c4086144825dac0b126
        PaymentLink: {
            name: 'Payment link',
            value: 'PaymentLink',
            sample: 'Please pay here https://example-payments.com/pay/INV-001',
        },
        PinchPaymentLink: pinchPaymentLink,
        InvoicePortalLink: Object.assign(Object.assign({}, invoicePortalLink), { sample: `https://portal.paidnice.com/i/example` }),
    },
    [EmailTemplateTypes.DISCOUNT]: {
        InvoiceContactName: invoiceContactName,
        ContactPersonName: contactPersonName,
        ContactPersonFirstName: contactPersonFirstName,
        OrganisationName: {
            name: 'Your Organisation Name',
            value: 'OrganisationName',
            sample: 'My Company Ltd',
        },
        InvoiceLink: directXeroLink,
        InvoiceNumber: {
            name: 'Invoice Number',
            value: 'InvoiceNumber',
            sample: 'INV-0001',
        },
        DueDate: {
            name: 'Due Date',
            value: 'DueDate',
            sample: '14 May 2022',
        },
        DaysUntilDue: {
            name: 'Days Until Due',
            value: 'DaysUntilDue',
            sample: '14',
        },
        DiscountRemoveDate: {
            name: 'Date when the discount will be removed',
            value: 'DiscountRemoveDate',
            sample: '14 May 2022',
        },
        DiscountAmount: {
            name: 'Prompt payment discount amount',
            value: 'DiscountAmount',
            sample: '$100.00',
        },
        InvoicePortalLink: invoicePortalLink,
        PinchPaymentLink: pinchPaymentLink,
    },
    [EmailTemplateTypes.STATEMENT_EMAIL]: {
        ContactPersonName: contactPersonName,
        ContactPersonFirstName: contactPersonFirstName,
        ContactName: {
            name: 'Contact Name',
            value: 'ContactName',
            sample: 'ABC Limited',
        },
        OrganisationName: {
            name: 'Your Organisation Name',
            value: 'OrganisationName',
            sample: 'My Company Ltd',
        },
        OutstandingBalance: {
            name: 'Outstanding Balance',
            value: 'OutstandingBalance',
            sample: '$10.00',
        },
        OverdueBalance: {
            name: 'Overdue Balance',
            value: 'OverdueBalance',
            sample: '$5.00',
        },
        StatementDate: {
            name: 'Statement Date',
            value: 'StatementDate',
            sample: `1st November 23 - 30th November 23 OR 1st November 23`,
        },
        OldestDueDate: {
            name: 'Oldest Due Date',
            value: 'OldestDueDate',
            sample: '14 May 2022',
            new: true,
        },
        MostRecentDueDate: {
            name: 'Most Recent Due Date',
            value: 'MostRecentDueDate',
            sample: '14 May 2022',
            new: true,
        },
        PortalStatementLink: statementPortalLink,
    },
    [EmailTemplateTypes.STATEMENT_INTEREST_EMAIL]: {
        ContactPersonName: contactPersonName,
        ContactPersonFirstName: contactPersonFirstName,
        ContactName: {
            name: 'Contact Name',
            value: 'ContactName',
            sample: 'ABC Limited',
        },
        OrganisationName: {
            name: 'Your Organisation Name',
            value: 'OrganisationName',
            sample: 'My Company Ltd',
        },
        InterestAmount: {
            name: 'Interest Amount',
            value: 'InterestAmount',
            sample: '$10.00',
        },
        NewOutstandingBalance: {
            name: 'New Outstanding Balance',
            value: 'NewOutstandingBalance',
            sample: '$10.00',
        },
        NewOverdueBalance: {
            name: 'New Overdue Balance',
            value: 'NewOverdueBalance',
            sample: '$5.00',
        },
        OriginalOverdueBalance: {
            name: 'Original Overdue Balance',
            value: 'OriginalOverdueBalance',
            sample: '$5.00',
        },
        PortalStatementLink: statementPortalLink,
        InterestInvoiceLink: Object.assign(Object.assign({}, invoicePortalLink), { name: `Interest Invoice Link`, value: 'InterestInvoiceLink' }),
    },
    [EmailTemplateTypes.ESCALATION]: {
        ContactName: {
            name: 'Contact Name',
            value: 'ContactName',
            sample: 'ABC Limited',
        },
        ContactPhone: {
            name: 'Contact Phone',
            value: 'ContactPhone',
            sample: '555-1234-7890',
        },
        ContactAddress: {
            name: 'Contact Address',
            value: 'ContactAddress',
            sample: '1223 North Street, New York, NY 10001',
        },
        OrganisationName: {
            name: 'Your Organisation Name',
            value: 'OrganisationName',
            sample: 'My Company Ltd',
        },
        DueDate: {
            name: 'Due Date',
            value: 'DueDate',
            sample: '14 May 2022',
        },
        DueAmount: {
            name: 'Due Amount',
            value: 'DueAmount',
            sample: '$250.00',
        },
        InvoiceNumber: {
            name: 'Invoice Number',
            value: 'InvoiceNumber',
            sample: 'INV-0001',
        },
    },
    [EmailTemplateTypes.INVOICE_REFERENCE]: {
        InvoiceNumber: {
            name: 'Original Invoice Number',
            value: 'OriginalInvoiceNumber',
            sample: 'INV-0001',
        },
    },
    [EmailTemplateTypes.ANNOUNCEMENT]: {
        ContactPersonName: contactPersonName,
        ContactPersonFirstName: contactPersonFirstName,
        ContactName: {
            name: 'Contact Name',
            value: 'ContactName',
            sample: 'ABC Limited',
        },
        OrganisationName: {
            name: 'Your Organisation Name',
            value: 'OrganisationName',
            sample: 'My Company Ltd',
        },
        PortalStatementLink: statementPortalLink,
    },
    [EmailTemplateTypes.QUOTE]: {
        ContactName: quoteContactName,
        ContactPersonName: contactPersonName,
        ContactPersonFirstName: contactPersonFirstName,
        OrganisationName: {
            name: 'Your Organisation Name',
            value: 'OrganisationName',
            sample: 'My Company Ltd',
        },
        PortalStatementLink: statementPortalLink,
        QuotePortalLink: quotePortalLink,
        ExpiryDate: {
            name: 'Expiry Date',
            value: 'ExpiryDate',
            sample: '14 May 2022',
        },
        QuoteNumber: {
            name: 'Quote Number',
            value: 'QuoteNumber',
            sample: 'QUO-0001',
        },
    },
};
//# sourceMappingURL=emailTemplateTypes.js.map